import React from "react";

import Page from "../../layouts/Main/Page";
import {useFeedbackTools} from "../../components/FeedbackTools";
import {useGlobalState} from "../../GlobalState";
import {useTemplates} from "./TemplatesContext";
import TopBarSelect from "./TopBarSelect";
import EmailEditor from "./EmailEditor";
import useEmailEditor from "./useEmailEditor";

import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import SendIcon from "@mui/icons-material/Send";
import Stack from "@mui/material/Stack";
import LoadingButton from "@mui/lab/LoadingButton";
import Alert from "@mui/material/Alert";


const EmailPreviewPage = (props) => {
    const {title, type, templateVariables, locale, onClose, onSend=f=>f} = props;
    const {
        templates,
        templatesLoaded,
        selectedTemplate,
        sendTemplateEmail,
        isSendingEmail,
        handleTemplateSelection
    } = useTemplates();

    const emailEditor = useEmailEditor(type, templateVariables, locale);
    const {showErrorNotification, showSuccessNotification, askConfirmation} = useFeedbackTools();
    const {settings, updateSettings} = useGlobalState();

    const handleSendEmail = async () => {
        try {
            const emailMessage = await sendTemplateEmail(selectedTemplate.id, {
                ...emailEditor.templateUserVariables,
                ...templateVariables,
                locale
            });
            onSend(emailMessage);
            onClose();
            showSuccessNotification("Invio email in corso...");
        } catch (e) {
            showErrorNotification(e);
        }
    }

    // Ask the confirmation when the email provider is default
    const handleClick = () => {
        if(settings?.emailProvider === "default" && !!settings?.notifyDefaultEmailProvider){
            askConfirmation({
                title: "Modifica servizio invio email",
                description: <>
                    L'email verrà inviata dai server email di LivignoItaly. Ti consigliamo fortemente di
                    selezionare un account Gmail o un altro metodo per l'invio delle email.
                    Dal menu principale seleziona "Impostazioni", dopodichè nella sezione "Servizio invio Email"
                    seleziona il metodo che preferisci.
                </>,
                confirmationText: 'Invia lo stesso',
                cancellationText: 'Annulla',
                showDoNotAskMeLater: true,
                doNotAskMeLaterMessage: "Non chiedermelo più.",
                onConfirm: async ({doNotAskMeLater}) => {
                    if (doNotAskMeLater) {
                        updateSettings({notifyDefaultEmailProvider: false})
                    }
                    handleSendEmail();
                }
            })
        }else{
            handleSendEmail();
        }
    }

    return <Page title={title}
                 disablePadding
                 onBack={onClose}
                 overlay
                 actions={<TopBarSelect options={templates}
                                        selected={selectedTemplate.id ? selectedTemplate : null}
                                        label="Seleziona modello"
                                        onSelection={(t) => handleTemplateSelection(t.id)}
                                        renderOption={(t) => t.name}/>}>
        <Container maxWidth="md" sx={{height: "100%"}}>
            <Stack sx={{pt: 1, height: "100%", mb: 15}} spacing={1}>
                <Typography variant="h6" textAlign="center">
                    (Anteprima mail)
                </Typography>

                {
                    (templatesLoaded && templates.length < 1) &&
                    <Alert severity="warning">
                        Nessun modello presente, per visualizzare l'anteprima mail occorre creare un modello.
                    </Alert>
                }
                <EmailEditor emailEditor={emailEditor}/>
            </Stack>

            <LoadingButton loading={isSendingEmail}
                           variant="contained"
                           color="primary"
                           size='medium'
                           disabled={emailEditor.isLoading || emailEditor.selectedTemplateId === null}
                           sx={{position: "fixed", bottom: 0, right: 0, mr: {xs: 2, md: 4}, mb: {xs: 2, md: 4}}}
                           onClick={handleClick}>
                <SendIcon sx={{mr: 1}}/>
                Invia
            </LoadingButton>
        </Container>
    </Page>
}

export default EmailPreviewPage;